var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineHeartSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 18.05c-1.98-1.86-4.35-4.99-4.35-9.36 0-3.5 2.83-6.34 6.31-6.34 1.69 0 3.27.66 4.44 1.84a6.214 6.214 0 0 1 4.44-1.84c1.26 0 2.48.38 3.53 1.08.34.23.43.7.2 1.04-.23.34-.7.43-1.04.2a4.74 4.74 0 0 0-2.68-.83c-1.52 0-2.93.71-3.84 1.94-.28.38-.92.38-1.2 0a4.765 4.765 0 0 0-3.84-1.94c-2.65 0-4.81 2.17-4.81 4.84 0 3.84 2.11 6.61 3.88 8.27.3.28.32.76.04 1.06a.83.83 0 0 1-.57.24c-.18 0-.37-.07-.51-.2zM11.14 21.52c-.75-.26-1.64-.68-2.5-1.19a.749.749 0 0 1-.26-1.03c.21-.35.67-.47 1.03-.26.78.46 1.57.84 2.22 1.06.18.06.57.06.75 0 2.3-.79 8.88-4.58 8.88-11.42 0-.5-.08-.99-.22-1.46-.12-.4.09-.82.49-.94s.82.1.94.49c.19.62.29 1.26.29 1.91 0 6.88-6.07 11.52-9.89 12.83-.26.1-.56.14-.87.14-.31 0-.61-.04-.86-.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.755.755 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHeartSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-heart-slash.7fb046f2016c242479cd121ee8129b4c.svg";
export { ForwardRef as ReactComponent };